import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import "./Slider.css";
import { CustomPrevArrow, CustomNextArrow } from "./CustomSliderArrow.js";
import ModalCarrinho from "../../utils/ModalCarrinho";
import Produto from "../cardProduto/CardProduto.js";

function MaisVendidos({ nome, btn, tipo }) {
  const [ebooks, setEbooks] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalItem, setModalItem] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const apiUrl = process.env.REACT_APP_API;

  useEffect(() => {
    const fetchEbook = async () => {
      try {
        let endpoint = apiUrl + "ebook";
        if (nome === "Mais Recentes") {
          endpoint = apiUrl + "ebooks-recentes";
        } else if (nome === "Mais Populares") {
          endpoint = apiUrl + "popular-ebooks";
        }

        const response = await fetch(endpoint);
        if (!response.ok) {
          throw new Error("Falha ao buscar o ebook");
        }
        const data = await response.json();
        setEbooks(data);
      } catch (error) {
        console.error("Erro ao buscar o ebook:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchEbook();
  }, [nome]);

  const handleAddToCart = (item) => {
    setModalItem(item);
  };

  useEffect(() => {
    if (modalItem) {
      setModalOpen(true);
    }
  }, [modalItem]);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const main = process.env.REACT_APP_MAIN;

  return (
    <div className="home-slider-wrapper">
      <h2>{nome}</h2>
      <div className="home-slider-container">
        <div className="maisvendidos-container">

          {isLoading ? (
            <div className="loading-container">
              <div className="loading-circle"></div>
            </div>
          ) : (
            <Slider {...settings}>
              {ebooks.map((product) => (
                <div key={product.id}>
                  <Produto
                    onAddToCartSlider={handleAddToCart}
                    slider={true}
                    livro={product}
                  />
                </div>

              ))}

            </Slider>
          )}


          {btn && (
            <Link
              className="main-btn alt"
              onClick={scrollToTop}
              to={main + "livros"}
            >
              CLIQUE AQUI PARA VER TODOS OS LIVROS
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default MaisVendidos;
